import { useNavigate } from 'react-router-dom';
import { routes } from '@/routes/routes';
import { useTrackOnboardingCompleted } from '@/lib/tracking';
import { VoltZeroBanner } from '../../components/VoltZeroBanner';
import styles from './PreliminaryNoScorePage.module.scss';

/**
 * No BC score to price a preliminary offer on (no credit history): Volt Zero
 * builds one.
 */
export function PreliminaryNoScorePage() {
  const navigate = useNavigate();

  useTrackOnboardingCompleted();

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <h1 className={styles.title}>Construiește-ți istoricul de credit 🚀</h1>
        <p className={styles.description}>
          📊 Nu ai încă un <strong>scor FICO</strong>.
        </p>
        <p className={styles.description}>
          👉 <strong>Volt Zero</strong> te ajută să începi de la zero.
        </p>
      </div>
      <VoltZeroBanner
        trackingId="preliminary_no_score_volt_zero"
        onClick={() => navigate(routes.offer.preliminaryVoltZero)}
      />
    </div>
  );
}

export default PreliminaryNoScorePage;
